import {
  EDIT_KNOWLEDGE_CATEGORY,
  EDIT_KNOWLEDGE_CATEGORY_CLEAN,
  EDIT_KNOWLEDGE_CATEGORY_SUCCESS,
  EDIT_KNOWLEDGE_CATEGORY_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  knowledgeCategory: undefined,
}

const KnowledgeCategoryEdit = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_KNOWLEDGE_CATEGORY:
      state = {
        ...state,
        loading: true,
      }
      break
    case EDIT_KNOWLEDGE_CATEGORY_SUCCESS:
      state = {
        ...state,
        loading: false,
        done: true,
        knowledgeCategory: action.payload.knowledgeCategory,
      }
      break
    case EDIT_KNOWLEDGE_CATEGORY_CLEAN:
      state = initialState
      break
    case EDIT_KNOWLEDGE_CATEGORY_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default KnowledgeCategoryEdit
